import {
  ChangeDetectorRef,
  Component,
  HostListener,
  OnInit,
  ViewEncapsulation,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Title } from "@angular/platform-browser";
import { ActivatedRoute, Router } from "@angular/router";
import { Location } from "@angular/common";
import * as _moment from "moment";
import { MatAutocompleteSelectedEvent } from "@angular/material/autocomplete";
import { BehaviorSubject, EMPTY, Observable, of, Subscription } from "rxjs";
import { catchError, concatMap, finalize, map, skip, take, pairwise } from 'rxjs/operators';
import { select, Store } from "@ngrx/store";
import { getEnabledSitesList } from "src/app/store/actions/sites/sites.actions";
import {
  AppState,
  loadedTenantState,
  sitesStateEnabledSitesList,
  sitesStateIsLoading,
} from "src/app/store/reducers";
import { TranslateService } from "@ngx-translate/core";
import { SnackbarService } from "src/app/shared/services/snackbar/snackbar.service";
import { SnackbarType } from "src/app/models/snackbar/snackbar.model";
import { TopCard } from "src/app/models/top-card/top-card.model";
import {
  Dialog,
  GuardConfirmationDialogData,
} from "src/app/models/dialog/dialog.model";
import { SiteCustomDTO } from "src/app/models/Sites/siteCustomDTO";
import { isAuthenticated } from "src/app/shared/utils/authenticationUtils";
import { ConfirmationDialogComponent } from "src/app/shared/modules/dialogs/confirmation-dialog/confirmation-dialog.component";
import { MatDialog } from "@angular/material/dialog";
import { SelectProductsDialogComponent } from "src/app/shared/modules/dialogs/select-products-dialog/select-products-dialog.component";
import { ProductService } from "src/app/shared/services/products/products/product.service";
import { MatSlideToggleChange } from "@angular/material/slide-toggle";
import { ProductPriceSchedulingDTO, ProductPriceSchedulingStatus } from "src/app/models/Products/priceSchedulingDTO";
import { ProductPriceSchedulingService } from "src/app/shared/services/products/products/productPriceScheduling.service";

import moment from "moment";
import { SitesService } from "src/app/shared/services/sites/sites.service";
import { CHIP_STYLE, getChipStyle } from "src/app/shared/utils/customTableUtils";

export const FORM_PARAMS = {
  siteCode: "siteCode",
  dateTimeStart: "dateTimeStart",
  dateTimeDisable: "dateTimeDisable",
  comment: "comment",
  oldPrice: "oldPrice",
  newPrice: "newPrice",
  status: "status",
  productCode: "productCode",
};

const PRICE_SCHEDULING = "ProductPriceScheduling.priceScheduling";

const ConfirmSchedulingAbovePercent = {
  data: {
    message: "ProductPriceScheduling.confirmChangeDialog.message",
    buttonText: {
      ok: "TableTemplate.ConfirmationDialog.AcceptButton",
      cancel: "TableTemplate.ConfirmationDialog.CancelButton",
    },
  },
};

@Component({
  selector: "app-product-price-scheduling-detail",
  templateUrl: "./product-price-scheduling-detail.component.html",
  styleUrls: ["./product-price-scheduling-detail.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class ProductPriceSchedulingDetailComponent implements OnInit {
  public isLoading$ = new BehaviorSubject<boolean>(false);
  public card: TopCard;
  public creation = false;
  public priceSchedulingDataForm: FormGroup;
  private langSubscription: Subscription;

  private currToken: string;
  public currentSchedule: ProductPriceSchedulingDTO;

  public isLoadingSites$: Observable<boolean>;
  public siteList$: Observable<SiteCustomDTO[]>;
  public siteList: SiteCustomDTO[] = [];
  public siteSubs: Subscription;
  public searchTimer: number;
  private currentSiteSub: Subscription;

  public dateTimeFormat: string;
  public currencySimbol: string;

  public priceSchedulingChecked = false;

  public unitPriceDecimalPlaces: number = 2;
  public forecourtUnitPriceDecimalPlaces: number = 2;

  public minDate = new Date();
  private tenantDataSub: Subscription;
  private tenantData$: Observable<any>;

  public selectedProducts: any[] = [];

  public differenceMode: "percentage" | "value" = "value";
  public differenceValue: number = null;

  private readonly CHANGE_LIMIT = 20;

  public displayedColumns: string[] = [
    "actions",
    "code",
    "description",
    "oldPrice",
    "newPrice",
    "difference",
  ];

  maxDate: Date;

  public defaultTime: number[] = [0, 0, 0];

  constructor(
    private router: Router,
    private location: Location,
    private titleService: Title,
    private translate: TranslateService,
    private productService: ProductService,
    private productPriceSchedulingService: ProductPriceSchedulingService,
    private snackbarService: SnackbarService,
    private fb: FormBuilder,
    private store: Store<AppState>,
    private dialog: MatDialog,
    private cdRef: ChangeDetectorRef,
    private route: ActivatedRoute,
    private sitesService: SitesService,
  ) {
    this.titleService.setTitle(this.translate.instant(PRICE_SCHEDULING));
    this.isLoadingSites$ = this.store.pipe(select(sitesStateIsLoading));
    this.siteList$ = this.store.pipe(select(sitesStateEnabledSitesList));
    this.tenantData$ = this.store.pipe(select(loadedTenantState));
  }

  ngOnInit(): void {
    const now = new Date();
    this.defaultTime = [now.getHours(), now.getMinutes(), now.getSeconds()];

    this.maxDate = _moment(new Date()).toDate();

    this.route.params.subscribe((params) => {
      const code = params.token;
      this.creation = false;

      this.router.routeReuseStrategy.shouldReuseRoute = () => false;
      if (code && code.length) {
        this.setOnInitialState(code);
      } else {
        this.creation = true;
        this.setOnInitialState("");
      }
    });
    this.loadLangChanges();
    this.createPriceSchedulingForm();
    this.setSiteSubs();
    this.loadTenantDateTimeFomat();
    if (!this.creation) this.loadPriceSchedule(this.currToken);
    this.listenValueChanges();
  }

  private loadLangChanges(): void {
    this.langSubscription = this.translate.onLangChange.subscribe(() => {
      this.titleService.setTitle(this.translate.instant(PRICE_SCHEDULING));
    });
  }

  private createPriceSchedulingForm(): void {
    this.priceSchedulingDataForm = this.fb.group({
      [FORM_PARAMS.siteCode]: [null, Validators.required],
      [FORM_PARAMS.dateTimeStart]: [null, Validators.required],
      [FORM_PARAMS.dateTimeDisable]: [{ value: null, disabled: true }],
      [FORM_PARAMS.comment]: [null, Validators.required],
    });
  }

  private setOnInitialState(token: string): void {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = "ignore";

    if (!token) {
      this.creation = true;
    } else {
      this.currToken = token;
      this.displayedColumns = ["code", "description", "oldPrice", "newPrice", "difference"];
    }
    this.setTopcard(token);
  }

  private setTopcard(title: string, status?: string): void {
    this.card = {
      avatarUrl: "",
      content: "",
      imageUrl: "",
      current: "",
      title:
        title && title.length
          ? title
          : "ProductPriceScheduling.newPriceScheduling",
      subtitle: PRICE_SCHEDULING,
      status: status ? this.setCustomStatusChip(status) : null,
    };
  }

  loadPriceSchedule(token: string) {
    this.isLoading$.next(true);
    this.productPriceSchedulingService
      .getProductPriceScheduling(token)
      .pipe(
        map(({ result }) => result),
        catchError((error) => {
          this.snackbarService.show({
            message:
              this.translate.instant(error) ??
              this.translate.instant("PriceScheduling.loadError"),
            type: SnackbarType.ERROR,
          });
          return EMPTY;
        }),
        finalize(() => this.isLoading$.next(false)),
      )
      .subscribe((schedule) => {
        if (schedule.comment)
          this.setTopcard(schedule.comment, schedule.status);
        this.setForm(schedule);
        this.currentSchedule = schedule;
      });
  }

  private setForm(schedule: ProductPriceSchedulingDTO) {
    this.currentSiteSub = this.sitesService
      .getSites()
      .pipe(
        map(({ result }) => result.items),
        catchError((error) => {
          this.snackbarService.show({
            message:
              this.translate.instant(error) ??
              this.translate.instant("PriceScheduling.loadSiteError"),
            type: SnackbarType.ERROR,
          });
          return EMPTY;
        }),
        finalize(() =>
          this.priceSchedulingDataForm.controls[FORM_PARAMS.siteCode].disable(),
        ),
      )
      .subscribe((sites) => {
        if (sites !== null && sites !== undefined) {
          const currSite = sites.find(
            (site) => site.siteNumber === schedule.siteNumber,
          );
          this.priceSchedulingDataForm.controls[FORM_PARAMS.siteCode].setValue({
            siteNumber: currSite.siteNumber,
            description: currSite.description,
          });
        }
      });
    this.priceSchedulingDataForm.controls[FORM_PARAMS.dateTimeStart].setValue(
      schedule.dateTimeStart,
    );
    this.priceSchedulingDataForm.controls[FORM_PARAMS.dateTimeStart].disable();
    this.priceSchedulingDataForm.controls[FORM_PARAMS.comment].setValue(
      schedule.comment,
    );
    this.priceSchedulingDataForm.controls[FORM_PARAMS.comment].disable();

    this.mergeSelectedProducts([
      {
        code: schedule.productCode,
        description: schedule.productDescription,
        productSiteUnitPriceGross: schedule.oldPrice,
        newPrice: schedule.newPrice,
      },
    ]);
  }

  setCustomStatusChip(status: any) {
    let style: CHIP_STYLE = CHIP_STYLE.INACTIVE;

    switch (status) {
      case ProductPriceSchedulingStatus.DEFINED:
      case ProductPriceSchedulingStatus.DEFINED_CLIENT:
      case ProductPriceSchedulingStatus.PENDING_FCC:
        style = CHIP_STYLE.STARTED;
        break;
      case ProductPriceSchedulingStatus.CHANGED:
        style = CHIP_STYLE.SUCCESS;
        break;
      case ProductPriceSchedulingStatus.INVALID:
        style = CHIP_STYLE.DANGER;
        break;
      case ProductPriceSchedulingStatus.EXPIRED:
      case ProductPriceSchedulingStatus.CANCELLED:
        style = CHIP_STYLE.INACTIVE;
        break;
    }

    let styleSettings = getChipStyle(style);

    return {
      value: this.translate.instant(
        "ProductPriceScheduling.statusConstants." + status,
      ),
      style: styleSettings.style,
      icon: styleSettings.icon,
    };
  }

  listenValueChanges() {
    this.priceSchedulingDataForm.controls[FORM_PARAMS.siteCode].valueChanges
    .pipe(pairwise())
    .subscribe(([previousSite, currentSite]) => {
      if (!this.creation) {
        return;
      }
  
      if (previousSite?.siteNumber === currentSite?.siteNumber) {
        return;
      }
  
      this.clearAllProducts();
    });
  }

  public back(): void {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.location.back();
  }

  public refresh(): void {
    if (
      isAuthenticated(this.router.url) &&
      !this.priceSchedulingDataForm.pristine
    ) {
      this.reload();
      return;
    } else {
      this.reload();
    }
  }

  reload() {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = "reload";
    this.router.navigate(["price-scheduling/" + this.currToken]);
  }

  private getDecimalsFor(product: any): number {
    if (!product) return this.unitPriceDecimalPlaces;
    return product.isFuel
      ? this.forecourtUnitPriceDecimalPlaces
      : this.unitPriceDecimalPlaces;
  }

  public getPriceStep(product?: any): string {
    const d = this.getDecimalsFor(product);
    if (d <= 0) return "1";
    const stepNum = 1 / Math.pow(10, d);
    return stepNum.toFixed(d);
  }

  public getDigitsInfo(product?: any): string {
    const d = this.getDecimalsFor(product);
    return `1.${d}-${d}`;
  }

  private roundNumber(v: number, decimals: number): number {
    if (v === null || v === undefined || isNaN(Number(v))) return null;
    const p = Math.pow(10, decimals);
    return Math.round(Number(v) * p) / p;
  }

  public onSelectedProductsFromDialog(productsFromDialog: any[]) {
    this.selectedProducts = (productsFromDialog || []).map((p) => {
      const oldPrice = Number(p.unitPriceGross) || 0;
      const decimals = this.getDecimalsFor(p);
      const newPrice = this.roundNumber(oldPrice, decimals);
      return {
        ...p,
        newPrice,
        differenceValue: 0,
        differencePercent: 0,
        editing: false,
      };
    });
    this.cdRef.markForCheck();
  }

  public openSearchProductsDialog(): void {
    if(!this.priceSchedulingDataForm.controls[FORM_PARAMS.siteCode].value) {
      return;
    }

    const dialogRef = this.dialog.open(SelectProductsDialogComponent, {
      width: "1400px",
      height: "80vh",
      panelClass: "search-customer-dialog",
      autoFocus: false,
      data: { 
        preselectedProducts: this.selectedProducts,
        siteCode: this.priceSchedulingDataForm.get(FORM_PARAMS.siteCode).value.siteNumber,
      },
    });

    dialogRef.afterClosed().subscribe((selectedProducts: any[] | undefined) => {
      if (!selectedProducts) return;
      this.mergeSelectedProducts(selectedProducts);
    });
  }

  openPriceSchedulingConfirmationDialog() {
    const dialogData: Dialog = ConfirmSchedulingAbovePercent;
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      ...dialogData,
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.createPriceScheduling();
      }
    });
  }

  private mergeSelectedProducts(newSelection: any[]) {
    const existingMap = new Map(this.selectedProducts.map((p) => [p.code, p]));

    newSelection.forEach((p) => {
      const decimals = this.getDecimalsFor(p);
      if (!existingMap.has(p.code)) {
        const oldPrice = Number(p.productSiteUnitPriceGross) || 0;
        let newPrice = this.roundNumber(oldPrice, decimals);

        const differenceValue = Number(this.differenceValue);
        if (
          this.differenceValue !== null &&
          this.differenceValue !== undefined &&
          !isNaN(differenceValue)
        ) {
          if (this.differenceMode === "value") {
            newPrice = this.roundNumber(oldPrice + differenceValue, decimals);
          } else {
            newPrice = this.roundNumber(
              oldPrice * (1 + differenceValue / 100),
              decimals,
            );
          }
        }
        newPrice = p.newPrice ?? newPrice;

        const newProduct = {
          ...p,
          newPrice,
          differenceValue: 0,
          differencePercent: 0,
          editing: false,
        };
        this.computeDifference(newProduct);
        existingMap.set(p.code, newProduct);
      } else {
        const existing = existingMap.get(p.code);
        existing.description = p.description;
        existing.unitPriceGross = p.unitPriceGross;
        this.computeDifference(existing);
      }
    });

    const newCodes = new Set(newSelection.map((p) => p.code));
    [...existingMap.keys()].forEach((code) => {
      if (!newCodes.has(code)) existingMap.delete(code);
    });

    this.selectedProducts = [...existingMap.values()];
    this.cdRef.markForCheck();
  }

  public removeProduct(product: any): void {
    this.selectedProducts = this.selectedProducts.filter(
      (p) => p.code !== product.code,
    );
  }

  public clearAllProducts(): void {
    if (!this.selectedProducts?.length) return;
    this.selectedProducts = [];
    this.differenceValue = null;
    this.cdRef.markForCheck();
  }

  public enforceDecimalPlaces(event: Event, product?: any): void {
    const inputEl = event.target as HTMLInputElement;
    let value = inputEl.value;
    if (!value) return;

    const decimals = this.getDecimalsFor(product);

    const firstDot = value.indexOf(".");
    if (firstDot !== -1) {
      const before = value.slice(0, firstDot + 1);
      const after = value.slice(firstDot + 1).replace(/\./g, "");
      value = before + after;
    }

    if (decimals === 0) {
      if (value.includes(".")) value = value.split(".")[0];
    } else {
      const parts = value.split(".");
      if (parts.length > 1 && parts[1].length > decimals) {
        parts[1] = parts[1].substring(0, decimals);
        value = parts[0] + "." + parts[1];
      }
    }

    if (inputEl.value !== value) {
      inputEl.value = value;
    }

    if (product) {
      product.newPrice = value;
    }
  }

  disablePriceScheduling() {
    this.priceSchedulingChecked = !this.priceSchedulingChecked;
    if (this.priceSchedulingChecked) {
      this.priceSchedulingDataForm.controls[
        FORM_PARAMS.dateTimeDisable
      ].enable();
      this.priceSchedulingDataForm.controls[
        FORM_PARAMS.dateTimeDisable
      ].setValidators(Validators.required);
    } else {
      this.priceSchedulingDataForm.controls[
        FORM_PARAMS.dateTimeDisable
      ].disable();
      this.priceSchedulingDataForm.controls[
        FORM_PARAMS.dateTimeDisable
      ].setValue(null);
    }
  }

  public blockMinus(evt: KeyboardEvent): void {
    if (evt.key === "-" || evt.key === "Subtract") {
      evt.preventDefault();
    }
  }

  public onNewPriceChange(product: any): void {
    const decimals = this.getDecimalsFor(product);
    let parsed = Number(product.newPrice);

    if (isNaN(parsed)) {
      product.newPrice = null;
      product.differenceValue = null;
      product.differencePercent = null;
      product.priceError = false;
      return;
    }

    if (parsed <= 0) {
      product.priceError = true;
      parsed = 0;
    } else {
      product.priceError = false;
    }

    product.newPrice = this.roundNumber(parsed, decimals);
    this.computeDifference(product);
  }

  private computeDifference(product: any): void {
    const decimals = this.getDecimalsFor(product);
    const oldPrice = Number(product.productSiteUnitPriceGross) || 0;
    const newPrice = Number(product.newPrice);

    if (isNaN(newPrice)) {
      product.differenceValue = null;
      product.differencePercent = null;
      return;
    }

    const diff = newPrice - oldPrice;
    product.differenceValue = this.roundNumber(diff, decimals);
    product.differencePercent =
      oldPrice > 0 ? this.roundNumber((diff / oldPrice) * 100, decimals) : null;
  }

  public onGlobalDifferenceBlur(): void {
    if (
      this.differenceValue === null ||
      this.differenceValue === undefined ||
      isNaN(Number(this.differenceValue))
    ) {
      return;
    }
    this.differenceValue = this.roundNumber(
      Number(this.differenceValue),
      this.unitPriceDecimalPlaces,
    );
    this.applyDifferenceToAll(this.differenceValue, this.differenceMode);
  }

  public applyDifferenceToAll(
    value: number,
    mode: "percentage" | "value",
  ): void {
    if (!this.selectedProducts?.length) return;
    if (value === null || value === undefined) return;

    const valueInput = Number(value);
    if (isNaN(valueInput)) return;

    this.differenceValue = this.roundNumber(
      valueInput,
      this.unitPriceDecimalPlaces,
    );

    this.selectedProducts.forEach((product) => {
      const oldPrice = Number(product.unitPriceGross) || 0;
      const decimals = this.getDecimalsFor(product);
      let newPrice = oldPrice;

      if (mode === "value") {
        newPrice = oldPrice + valueInput;
      } else {
        newPrice = oldPrice * (1 + valueInput / 100);
      }

      product.newPrice = this.roundNumber(newPrice, decimals);
      this.computeDifference(product);
    });

    this.selectedProducts = [...this.selectedProducts];
    this.cdRef.markForCheck();
  }

  public onDifferenceModeChange(event: MatSlideToggleChange): void {
    this.differenceMode = event.checked ? "percentage" : "value";

    if (
      this.differenceValue !== null &&
      this.differenceValue !== undefined &&
      !isNaN(Number(this.differenceValue))
    ) {
      this.differenceValue = this.roundNumber(
        Number(this.differenceValue),
        this.unitPriceDecimalPlaces,
      );
      this.applyDifferenceToAll(this.differenceValue, this.differenceMode);
    }
  }

  onDifferenceBlur(): void {
    if (
      this.differenceValue === null ||
      this.differenceValue === undefined ||
      isNaN(Number(this.differenceValue))
    ) {
      this.differenceValue = 0;
    } else {
      this.differenceValue = this.roundNumber(
        Number(this.differenceValue),
        this.unitPriceDecimalPlaces,
      );
    }

    this.applyDifferenceToAll(this.differenceValue, this.differenceMode);
  }

  public getDiffClass(product: any): string {
    if (product.differenceValue == null) return "diff-neutral";
    if (product.differenceValue > 0) return "diff-up";
    if (product.differenceValue < 0) return "diff-down";
    return "diff-neutral";
  }

  public checkPercentageChange(): void {
    if (this.priceSchedulingDataForm.invalid) {
      this.priceSchedulingDataForm.markAllAsTouched();
      return;
    }

    if (!this.selectedProducts.length) {
      this.snackbarService.show({
        message: this.translate.instant(
          "ProductPriceScheduling.noProductSelected",
        ),
        type: SnackbarType.WARNING,
      });
      return;
    }

    const hasOverLimit = this.selectedProducts.some((p) => {
      const percentChange = Number(p?.differencePercent);
      return (
        Number.isFinite(percentChange) &&
        Math.abs(percentChange) > this.CHANGE_LIMIT
      );
    });

    if (hasOverLimit) {
      this.openPriceSchedulingConfirmationDialog();
    } else {
      this.createPriceScheduling();
    }
  }

  // create a method to return price scheduling building data from form, to be used with checkbox option
  private buildPriceSchedulingData(): {
    create: ProductPriceSchedulingDTO[];
    disable?: ProductPriceSchedulingDTO[];
  } {
    // so here if checkbox is checked, we send two requests, one to create the scheduling, and another to disable
    // but for that we need to create two different ProductPriceSchedulingDTO objects per product
    // the second one is sended with dateTimeStart as dateTimeDisable value and price as oldPrice (to disable we set newPrice = oldPrice)

    const formValue = this.priceSchedulingDataForm.value;

    const startDateTimeString = this.priceSchedulingDataForm.controls[
      FORM_PARAMS.dateTimeStart
    ].value
      ? moment(
          this.priceSchedulingDataForm.controls[FORM_PARAMS.dateTimeStart]
            .value,
        ).format("YYYY-MM-DDTHH:mm:ss")
      : null;

    const create: ProductPriceSchedulingDTO[] = (
      this.selectedProducts || []
    ).map((product) => ({
      comment: formValue.comment,
      oldPrice: Number(product.productSiteUnitPriceGross),
      newPrice: Number(product.newPrice),
      dateTimeStart: startDateTimeString,
      productCode: product.code,
      siteNumber: formValue.siteCode.siteNumber,
      productDescription: product.description,
    }));

    if (!this.priceSchedulingChecked) return { create };

    const disableCtrl =
      this.priceSchedulingDataForm.controls[FORM_PARAMS.dateTimeDisable];
    const disableDate = disableCtrl.value;
    if (!disableDate) {
      this.snackbarService.show({
        message: this.translate.instant(
          "ProductPriceScheduling.missingDisableDate",
        ),
        type: SnackbarType.WARNING,
      });
      return { create };
    }

    const disableStr = moment(disableDate).format("YYYY-MM-DDTHH:mm:ss");

    // disable date has to be after start date
    if (
      startDateTimeString &&
      moment(disableStr).isBefore(startDateTimeString)
    ) {
      this.snackbarService.show({
        message: this.translate.instant(
          "ProductPriceScheduling.disableMustBeAfterStart",
        ),
        type: SnackbarType.ERROR,
      });
      return { create };
    }

    const disable: ProductPriceSchedulingDTO[] = (
      this.selectedProducts || []
    ).map((product) => ({
      comment: formValue.comment,
      oldPrice: Number(product.productSiteUnitPriceGross),
      newPrice: Number(product.productSiteUnitPriceGross), // revert to old price
      dateTimeStart: disableStr, // schedule the disable at this time
      productCode: product.code,
      siteNumber: formValue.siteCode.siteNumber,
      productDescription: product.description,
    }));

    return { create, disable };
  }

  public createPriceScheduling(): void {
    if (this.priceSchedulingDataForm.invalid) {
      this.priceSchedulingDataForm.markAllAsTouched();
      return;
    }
    if (!this.selectedProducts.length) {
      this.snackbarService.show({
        message: this.translate.instant(
          "ProductPriceScheduling.noProductSelected",
        ),
        type: SnackbarType.WARNING,
      });
      return;
    }

    const { create, disable } = this.buildPriceSchedulingData();
    if (!create?.length) return;

    this.isLoading$.next(true);

    const first$ =
      this.productPriceSchedulingService.createProductPriceSchedulingBatch(
        create,
      );
    const second$ = disable?.length
      ? this.productPriceSchedulingService.createProductPriceSchedulingBatch(
          disable,
        )
      : of(null);

    first$
      .pipe(
        concatMap(() => second$),
        finalize(() => this.isLoading$.next(false)),
        catchError((error) => {
          this.snackbarService.show({
            message:
              this.translate.instant(error) ??
              this.translate.instant("PriceScheduling.createdError"),
            type: SnackbarType.ERROR,
          });
          return EMPTY;
        }),
      )
      .subscribe(() => {
        this.router.navigate(["/price-scheduling"]);
        this.snackbarService.show({
          message: this.translate.instant(
            "ProductPriceScheduling.createdSuccess",
          ),
          type: SnackbarType.SUCCESS,
        });
      });
  }

  @HostListener("window:beforeunload")
  public canDeactivate(): Observable<boolean> | boolean {
    return this.isNavigationAllowed();
  }

  public isNavigationAllowed(): Observable<boolean> | boolean {
    if (
      !isAuthenticated(this.router.url) ||
      this.priceSchedulingDataForm.pristine
    ) {
      return true;
    }
    return false;
  }

  public confirmDialog(dialog: any, refresh = false): Observable<boolean> {
    const dialogData: Dialog = GuardConfirmationDialogData;
    const dialogRef = dialog.open(ConfirmationDialogComponent, dialogData);
    if (!refresh) {
      return dialogRef.afterClosed();
    }
    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (result) {
        this.reload();
      }
    });
  }

  public validateFirstSiteSearch(): void {
    this.searchSites("");
  }

  public searchSites(event: KeyboardEvent | string, hasTimer = true): void {
    const searchTerm =
      typeof event === "string"
        ? event
        : (event.target as HTMLInputElement).value;

    clearTimeout(this.searchTimer);
    this.searchTimer = window.setTimeout(
      () => {
        this.store.dispatch(
          getEnabledSitesList({
            options: {
              filteringArgs: {
                filterConfig: [
                  { field: "siteNumber" },
                  { field: "description" },
                ],
                searchTerms: [searchTerm],
              },
            },
          }),
        );
      },
      hasTimer ? 500 : 0,
    );
  }

  public displaySite(site: {
    siteNumber: string;
    description: string;
  }): string {
    return site?.description ?? "";
  }

  private setSiteSubs(): void {
    this.siteList = [];
    this.siteSubs = this.siteList$.pipe(skip(1)).subscribe((sites) => {
      if (sites !== null && sites !== undefined) {
        this.siteList = sites.map(({ code, siteNumber, description }) => {
          return {
            code: code,
            siteNumber: siteNumber,
            description: description ?? "",
          };
        });
      }
    });
  }

  public siteSelected(selectedOption: MatAutocompleteSelectedEvent) {
    const { option } = selectedOption;
    const { siteNumber, description } = option?.value;

    this.priceSchedulingDataForm.controls[FORM_PARAMS.siteCode].setValue({
      siteNumber: siteNumber,
      description: description,
    });
  }

  private loadTenantDateTimeFomat(): void {
    this.tenantDataSub = this.tenantData$.subscribe((data: any) => {
      if (data) {
        this.dateTimeFormat = data.datetimeFormat;
        this.currencySimbol = data.currency?.symbol;

        const basePlaces =
          typeof data.unitPriceDecimalPlaces === "number"
            ? data.unitPriceDecimalPlaces
            : this.unitPriceDecimalPlaces;

        const forecourtPlaces =
          typeof data.forecourtUnitPriceDecimalPlaces === "number"
            ? data.forecourtUnitPriceDecimalPlaces
            : basePlaces;

        const changed =
          basePlaces !== this.unitPriceDecimalPlaces ||
          forecourtPlaces !== this.forecourtUnitPriceDecimalPlaces;

        this.unitPriceDecimalPlaces = basePlaces;
        this.forecourtUnitPriceDecimalPlaces = forecourtPlaces;

        if (changed && this.selectedProducts.length) {
          this.selectedProducts.forEach((p) => {
            const dec = this.getDecimalsFor(p);
            if (p.newPrice != null) {
              p.newPrice = this.roundNumber(Number(p.newPrice), dec);
              this.computeDifference(p);
            }
          });
          this.selectedProducts = [...this.selectedProducts];
          this.cdRef.markForCheck();
        }
      }
    });
  }

  get formFlex(): string {
    return this.creation ? "0 1 33.3%" : "0 1 50%";
  }

  createNew() {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = "reload";
    this.router.navigate(["/price-scheduling/new"]);
    this.creation = true;
  }

  public ngOnDestroy(): void {
    this.langSubscription?.unsubscribe();
    this.tenantDataSub?.unsubscribe();
    this.siteSubs?.unsubscribe();
    this.currentSiteSub?.unsubscribe();
  }
}
